import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import map from '../components/map.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "join" */ '../views/join.vue')
  },
  {
    path: '/online',
    name: 'online',
    component: () => import(/* webpackChunkName: "join" */ '../views/online.vue')
  },
  {
    path: '/sign',
    name: 'sign',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  },
  {
    path: '/check-campus',
    name: 'check-campus',
    component: () => import(/* webpackChunkName: "about" */ '../views/check-campus.vue')
  },
  {
    path: '/map',
    name: 'map',
    component: map
  },
  {
    path: '/social',
    name: 'social',
    component: () => import('../components/social-responsibility.vue')
  },
  {
    path: '/',
    name: 'homeV2',
    component: () => import(/* webpackChunkName: "join" */ '../views/homeV2')
  },
  {
    path: '/socialV2',
    name: 'socialV2',
    component: () => import('../components/homeV2/SocilReponbilltyV2.vue')
  },
  {
    path: '/test3333',
    name: 'test3333',
    component: () => import(/* webpackChunkName: "join" */ '../views/test3333')
  },
  // 重定向
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes,
  /* scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  } */
})
export default router
